import React from 'react';
import { useParams } from 'react-router-dom';
import JobList from './JobList';

const JobListWrapper = () => {
	let { filter } = useParams(); // Use the useParams hook to access the URL parameter

	// console.log("Filter:", filter);

	// if (filter === ':filter' || filter === 'none') { // Check if the parameter is present
	// 	filter = 'none';
	// 	//tidy up the url to remove the :filter
	// 	window.history.replaceState({}, document.title, window.location.pathname.replace('/:filter', '').replace('/none', ''));
	// }

	// if (job === ':job') { // Check if the parameter is present
	// 	job = 'none';
	// 	//tidy up the url to remove the :filter
	// 	window.history.replaceState({}, document.title, window.location.pathname.replace('/:job', ''));
	// }

	// window.history.replaceState({}, document.title, window.location.pathname.replace('/none', ''));

	return <JobList filter={filter} />; 
};

export default JobListWrapper;